import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { StockTypesQuery } from "../../../graphql/deliveryService/queries/stockTypes";
import { StockTypesPagedFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface useStockTypesQueryProps {
  dataAction: (data: StockTypesPagedFragment) => void;
  errorAction?: () => void;
}

const useStockTypesQuery = (props: useStockTypesQueryProps) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const query = useQuery(StockTypesQuery, {
    variables: { offset: 0, limit: 50 },
  });

  const { data, error } = query;

  const stockTypesPagedFragment = data?.stockTypes;

  useEffect(() => {
    if (!error) return;

    handleError(t("stockTypesError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !stockTypesPagedFragment) return;

    dataAction(stockTypesPagedFragment);
  }, [data]);

  return query;
};

export default useStockTypesQuery;
